import React from 'react'
import styled, { css } from 'styled-components'
import { CloseIcon } from '@mote/assets/icons'
import { preventBubblingEvent } from '@mote/helpers/browser'

export const CloseButton = React.forwardRef(({ onClick, ...props }, ref) => {
  return (
    <Root
      ref={ref}
      size={40}
      aria-label='Close'
      onClick={event => {
        preventBubblingEvent(event)
        onClick?.(event)
      }}
      onKeyDown={event => {
        switch (event.keyCode) {
          case KeyboardKey.Space:
          case KeyboardKey.Enter:
            preventBubblingEvent(event)
            onClick?.(event)
            break
        }
      }}
      {...props}
    >
      <CloseIcon color='currentColor' />
    </Root>
  )
})

const Root = styled.button`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #232323;
  border-radius: 4px;
  border: 0;
  padding: 0;
  appearance: none;
  user-select: none;
  background-color: transparent;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
  transition: all 150ms ease-in;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;

  &:hover,
  &:focus {
    background: #f6f6f9;
  }

  &:focus {
    box-shadow: 0 0 0 3px rgba(172, 10, 231, 0.4);
  }

  ${({ size }) =>
    size !== undefined &&
    css`
      width: ${size}px;
      height: ${size}px;

      svg {
        height: ${size / 1.5}px;
        width: ${size / 1.5}px;
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
    `};
`
